import React, { useContext } from 'react';
import { Modal } from 'common';

import ContactsDetailsHeader from './ContactsDetailsHeader.component';
import ClearAllModal from './ClearAllModal.component';

const { ModalContext } = Modal;

const MultiContactEditView = ({
	selectedContacts,
	deleteContacts,
	onPrintPostageClick,
	clearSelectedContacts,
}) => {
	const { showModal } = useContext(ModalContext);

	const launchClearAllModal = () => {
		showModal({
			component: ClearAllModal,
			data: { clearSelectedContacts },
		});
	};

	return (
		<div className="contacts-details">
			<ContactsDetailsHeader
				headerText="Multiple Selections"
				selectedContacts={selectedContacts}
				onPrintPostageClick={onPrintPostageClick}
				deleteContacts={deleteContacts}
			/>
			<div className="body">
				<p>{`${selectedContacts.length} contacts Selected`}</p>
				<a className="clearAll" role="button" tabIndex="0" onClick={launchClearAllModal}>
					(Clear All)
				</a>
			</div>
		</div>
	);
};

export default MultiContactEditView;
